import { DestroyRef, Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { BaseComponent } from '@app/components/base.component';
import { Store } from '@ngrx/store';
import { UserState } from '@app/store/user/state';
import { UDFApiService } from './udf-api.service';
import { selectUserName } from '@app/store/user/selector';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SuccessStory } from '@app/store/stories/state';

@Injectable({
  providedIn: 'root',
})
export class SuccessStoryService extends BaseComponent {
  private destroyServiceRef = inject(DestroyRef);
  private user: any;
  getusername: any;
  newuser: any;
  udfApiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private userStore: Store<{ userState: UserState }>,
    private udfApiSvc: UDFApiService
  ) {
    super();
    this.udfApiUrl = environment.udfApiUrl;
    // this.udfApiUrl = "https://localhost:5050";
    this.subscribeToStore(this.userStore.select(selectUserName), un => {
      if (un) {
        this.udfApiSvc
          .getGraphUser(un)
          .pipe(takeUntilDestroyed(this.destroyServiceRef))
          .subscribe(u => {
            this.user = u.value.map(p => ({
              oid: p.id,
              displayName: p.displayName,
              upn: p.userPrincipalName,
            }));
          });
      }
    });
  }

  userName() {
    try {
      this.getusername = this.user[0];
      return this.getusername;
    } catch (err) {
      this.getusername = 'No Data found';
      return this.getusername;
    }
  }

  create(payload: SuccessStory, files): Observable<SuccessStory> {
    payload.post_by = this.user;
    let formData = new FormData();
    //TODO REMOVE SUMMARY FROM API UDF SERVICE IN THE FUTURE
    formData.append('payload', JSON.stringify({ ...payload, summary: '' }));
    if (files?.cover_image) {
      formData.append(
        'cover_image',
        files.cover_image,
        files.cover_image.filename
      );
    }
    if (files.content_images) {
      for (let i = 0; i < files?.content_images?.length; i++) {
        formData.append(
          `main_image_${i}`,
          files.content_images[i],
          files.content_images[i].filename
        );
      }
    }
    if (files.video) {
      formData.append('video', files.video, files.video.filename);
    }

    const url = `${this.udfApiUrl}/api/Snowflake/addSuccessStories`;
    return this.httpClient.post<SuccessStory>(url, formData);
  }

  getbyid(id: number): Observable<SuccessStory> {
    return this.httpClient.get<SuccessStory>(
      `${this.udfApiUrl}/api/Snowflake/getSuccessStoryByStoryId?storyId=${id}`
    );
  }

  updateStory(
    payload: SuccessStory,
    files,
    id: number
  ): Observable<Partial<SuccessStory>> {
    payload.modified_by = this.user;
    let formData = new FormData();
    //TODO REMOVE SUMMARY FROM API UDF SERVICE IN THE FUTURE
    formData.append('payload', JSON.stringify({ ...payload, summary: '' }));
    if (files?.cover_image) {
      formData.append(
        'cover_image',
        files.cover_image,
        files.cover_image.filename
      );
    }
    if (files.content_images) {
      for (let i = 0; i < files.content_images?.length; i++) {
        formData.append(
          `main_image_${i}`,
          files.content_images[i],
          files.content_images[i].filename
        );
      }
    }
    if (files.video) {
      formData.append('video', files.video, files.video.filename);
    }

    // return new Observable();
    return this.httpClient.put<Partial<SuccessStory>>(
      `${this.udfApiUrl}/api/Snowflake/updateSuccessStories?storyId=${id}`,
      formData
    );
  }

  getAll(page?: number, pageSize?: number): Observable<any> {
    return this.httpClient
      .get(
        `${this.udfApiUrl}/api/Snowflake/getSuccessStories?page=${page ?? 1}&pageSize=${pageSize ?? 9}`
      )
      .pipe(catchError(this.handleHttpError));
    // return this.http.get(`${this.udfApiUrl}/api/Tag`);
    // .pipe(catchError(this.handleHttpError));
    // return this.http.get(`${this.udfApiUrl}/api/allscuccessstory`);
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(
      `${this.udfApiUrl}/api/Snowflake/deleteSuccessStory?storyId=${id}`
    );
  }

  handleHttpError(error) {
    return throwError(error.message || 'Server Error');
  }
}
